var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  stroke: "#6D838F"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(8, 8)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0L6.852 1.1144L12.9376 7.2L0 7.2L0 8.8L12.9376 8.8L6.8688 14.8688L8 16C10.9288 13.0712 13.1968 10.8032 16 8C12.8272 4.8272 15.0672 7.0672 8 0Z",
  fill: "#3E5660"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-arrow-right.0447459e29997d240a1b0457046c6e14.svg";